import React from "react";
import { cn } from "src/utils/cn";
import { STATUS_META, OUTCOME_META, CHECKIN_META } from "src/features/site_visits/constants";

const MAPS = { status: STATUS_META, outcome: OUTCOME_META, checkin: CHECKIN_META };

export function StatusBadge({ value, kind = "status" }) {
  if (!value) return null;
  const meta = MAPS[kind]?.[value] || { label: value, className: "bg-slate-100 text-slate-600" };
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold",
        meta.className
      )}
    >
      {meta.label}
    </span>
  );
}
